module.exports = __webpack_public_path__ + "static/media/floral-design-like-a-heart-of-symmetric-spirals-of-thin-lines-svgrepo-com.75ccbe05.svg";